//import { toSearchableString } from 'app/utils';

const TEMPLATE_NAME = 'KIT_MAT_MED';

const initialState = () => ({
  loading: false,
  loadedData: [],
  filter: {
    term: '',
    data: []
  }
});

//const filterByTerm = (item, term) => toSearchableString(item).includes(toSearchableString(term));
/*
const filterData = (data, term) => {
  const result = data.filter((item) => {
    const kitName = item.name ? filterByTerm(item.name, term) : false;
    const kitDescription = item.description
      ? filterByTerm(item.description, term)
      : false;
    const kitType = item.type.name ? filterByTerm(item.type.name, term) : false;
    const kitClientName = item.client.name
      ? filterByTerm(item.client.name, term)
      : false;

    return kitName || kitDescription || kitType || kitClientName;
  });

  return result;
};
*/
const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }
    case `${TEMPLATE_NAME}_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }
    case `${TEMPLATE_NAME}_FULFILLED`: {
      //const currentData = state.loadedData;
      const newData = action.payload;
      const loadedData = newData;
      //console.log(loadedData);
      return {
        ...state,
        loading: false,
        loadedData,
        filter: {
          ...state.filter,
          data: loadedData
        }
      };
    }
    case `${TEMPLATE_NAME}_UPDATE`: {
      //console.log(loadedData);
      //console.log(typeof state.loadedData);
      const updatedRow = action.payload;
      const loadedData = updatedRow;
      //console.log(updatedRow);
      //console.log(loadedData);
      return {
        ...state,
        loadedData: updatedRow,
        filter: {
          ...state.filter,
          data: loadedData
        }
      };
    }

    case `${TEMPLATE_NAME}_RESET`: {
      return initialState();
    }

    default:
      return state;
  }
};

export default reducer;
